export const cleanOrganizationFromLocalStorage = () => {
  localStorage.removeItem('organizationId');
};

export const setOrganizationToLocalStorage = (organizationId: string) => {
  localStorage.setItem('organizationId', organizationId);
};

export const getOrganization = () => localStorage.getItem('organizationId');
